import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Highcharts from 'highcharts';
import { HighchartsCustomTheme } from './app/shared/highcharts-theme';

// ✅ Set the Highcharts global theme before bootstrapping
Highcharts.setOptions(HighchartsCustomTheme);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
